<template>
  <div class="benefits-container">
    <div class="benefits-list">
      <div v-for="(item,index) in benefits" :key="index" class="benefit-item">
        <div class="blur-item"></div>
        <img :src="item.url" alt="benefits" class="image">
        <span class="title">{{ item.header }}</span>
      </div>
    </div>
    <span class="about">
Diversification is a technique that reduces risk by allocating investments across various financial instruments, industries,
      and other categories. It aims to maximize returns by investing in different areas that would each react differently to the same event.
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      benefits: [
        {
          url: require('../../../assets/images/holding.png'),
          header: 'Diversified Investments'
        },
        {
          url: require('../../../assets/images/origination.png'),
          header: 'Referral System'
        },
        {
          url: require('../../../assets/images/withdrawal.png'),
          header: 'High APR'
        },
        {
          url: require('../../../assets/images/transfer.png'),
          header: 'Earn Stable Coin'
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.benefits-container {
  position: relative;
  background: linear-gradient(109.04deg, #03010F 2.08%, #02000E 53.47%, #090D23 89.81%);
  padding: 161px 10% 141px;
  @media only screen and (max-width: 1023px) {
    padding: 50px 20px 40px;
    background: #070A1E;
  }

  .benefits-list {
    @include flex;
    width: fit-content;
    margin: 0 auto;
    @media only screen and (max-width: 767px) {
      flex-direction: column;
    }

    .benefit-item {
      @include flex;
      position: relative;
      flex-direction: column;
      margin-right: 134px;
      @media only screen and (max-width: 1650px) and (min-width: 1441px) {
        margin-right: 100px;
      }
      @media only screen and (max-width: 1440px) and (min-width: 1366px) {
        margin-right: 75px;
      }
      @media only screen and (max-width: 1365px) and (min-width: 1024px) {
        margin-right: 50px;
      }
      @media only screen and (max-width: 1023px) and (min-width: 768px) {
        margin-right: 25px;
      }
      @media only screen and (max-width: 767px) {
        margin-right: 0;
        margin-top: 50px;
        &:first-child {
          margin-top: 0;
        }
      }

      &:last-child {
        margin-right: 0;
      }

      .blur-item {
        position: absolute;
        width: 224px;
        height: 169.98px;
        background: rgba(66, 232, 224, 0.4);
        filter: blur(110px);
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        @media only screen and (max-width: 1365px) and (min-width: 1024px) {
          width: 180px;
          height: 120px;
        }
        @media only screen and (max-width: 767px) {
          width: 220px;
          height: 150px;
        }
      }

      .image {

      }

      .title {
        margin-top: 26px;
        font-weight: 500;
        font-size: 25px;
        text-align: center;
        line-height: 38px;
        color: #FFFFFF;
        max-width: 80%;
        @media only screen and (max-width: 1365px) and (min-width: 1024px) {
          font-size: 20px;
          line-height: 28px;
        }
        @media only screen and (max-width: 1023px) and (min-width: 768px) {
          font-size: 18px;
          line-height: 26px;
        }
        @media only screen and (max-width: 767px) {
          font-size: 22px;
          line-height: 26px;
          max-width: 100%;
        }

      }
    }
  }

  .about {
    display: block;
    max-width: 739px;
    margin: 72px auto 0;
    font-weight: 300;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: #FFFFFF;
    @media only screen and (max-width: 1023px) and (min-width: 768px) {
      max-width: 500px;
      margin: 52px auto 0;
      font-size: 16px;
    }
    @media only screen and (max-width: 767px) {
      margin: 30px auto 0;
    }
  }
}
</style>